"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _cnbuilder = require("cnbuilder");
var _reactI18next = require("react-i18next");
var _alertDefault = _interopRequireDefault(require("@teladoc/pulse/icons/alert-default.svg"));
var _Button = _interopRequireDefault(require("../Button"));
var _Image = _interopRequireDefault(require("../Image"));
var _ErrorBoundaryModule = _interopRequireDefault(require("./ErrorBoundary.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
class ErrorBoundary extends _react.Component {
  constructor() {
    super(...arguments);
    this.state = {
      error: null,
      loadContent: this.props.variant === 'inline'
    };
    this._onLoad = () => {
      this.setState({
        loadContent: true
      });
    };
  }
  componentDidCatch(error, info) {
    const {
      onError
    } = this.props;
    this.setState({
      error
    });
    if (onError) {
      onError(error, info);
    }
  }
  render() {
    const {
      className,
      testAttrRoot,
      testAttrContent,
      testAttrButton,
      i18nHeading,
      i18nDescription,
      i18nButton,
      variant,
      type,
      memberSupportLink,
      children,
      errorComponent,
      onButtonClick
    } = this.props;
    const {
      error,
      loadContent
    } = this.state;
    if (error) {
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: (0, _cnbuilder.cnb)(_ErrorBoundaryModule.default.root, _ErrorBoundaryModule.default[variant], className),
        "data-testid": testAttrRoot,
        "aria-live": "assertive",
        children: [!errorComponent && variant === 'inline' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_alertDefault.default, {
          className: _ErrorBoundaryModule.default.icon
        }), errorComponent || /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          "data-testid": testAttrContent,
          children: [variant !== 'inline' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Image.default, {
            cloudinaryImageId: "pulse/error-boundary/error-".concat(type),
            width: 228,
            height: 138,
            alt: "",
            onLoad: this._onLoad
          }), loadContent && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h1", {
              className: (0, _cnbuilder.cnb)({
                [_ErrorBoundaryModule.default['heading-xs']]: variant === 'inline'
              }, {
                [_ErrorBoundaryModule.default['heading-md']]: variant !== 'inline'
              }),
              children: i18nHeading || /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactI18next.Trans, {
                i18nKey: "ui:errorBoundary.".concat(variant, ".heading")
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
              className: _ErrorBoundaryModule.default.description,
              children: i18nDescription || /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactI18next.Trans, {
                i18nKey: "ui:errorBoundary.".concat(variant, ".description"),
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("a", {
                  href: memberSupportLink,
                  target: "_blank",
                  rel: "noopener noreferrer",
                  children: "member support"
                })
              })
            }), variant === 'notFound' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
              className: _ErrorBoundaryModule.default.button,
              testAttr: testAttrButton,
              variant: "primary",
              onClick: onButtonClick,
              children: i18nButton || /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactI18next.Trans, {
                i18nKey: "ui:errorBoundary.".concat(variant, ".cta")
              })
            })]
          })]
        })]
      });
    }
    return children;
  }
}
exports.default = ErrorBoundary;
ErrorBoundary.defaultProps = {
  testAttrRoot: 'error-boundary-root',
  testAttrContent: 'error-boundary-content',
  testAttrButton: 'error-boundary-button',
  variant: 'inline',
  type: 'member',
  memberSupportLink: 'https://livongo.zendesk.com/hc/en-us/categories/115001480808-Member-Self-Help-Center'
};